import * as React from 'react';
import { css, StyleSheet } from 'aphrodite/no-important';
import { MEDIA_BREAKPOINTS } from '../../mediaQueries.const';
import { useTheme } from '../../theming/useTheme';
import { VrLineHeight } from '../../theming/verticalRhythm/verticalRhythm';
import { Ad } from '../ads/Ad';
import { AdditionalStyleSheet } from '../components.utils';
import { getHeaderHeight } from '../components/navigation/header/header.utils';

const componentConfigurationKey = 'postSidebar';

interface PostSidebarThemeProps {
  vrLineHeight: VrLineHeight
}

interface PostSideBarDataProps {
    adId1: string | null
    adId2: string | null
    isSecondaryHeaderEnabled: boolean
}

type PostSidebarComponent = PostSidebarThemeProps & PostSideBarDataProps;

const createStyle = (vrLineHeight: VrLineHeight) => {
  return StyleSheet.create({
    sidebar: {
      gridRowEnd: 'span 2',
      [MEDIA_BREAKPOINTS.LARGE]: {
        gridRowEnd: 'span 2',
        padding: `${vrLineHeight[MEDIA_BREAKPOINTS.LARGE]}px`,
      },
      [MEDIA_BREAKPOINTS.MEDIUM]: {
        display: 'none',
      },
      [MEDIA_BREAKPOINTS.SMALL]: {
        display: 'none',
      },
    },
  });
};

const createAdditionalStyleForStickyAd = (headerHeight: number, vrLineHeight:VrLineHeight) => {
  return StyleSheet.create({
    style: {
      position: 'sticky',
      top: headerHeight,
      [MEDIA_BREAKPOINTS.LARGE]: {
        paddingTop: `${vrLineHeight[MEDIA_BREAKPOINTS.LARGE]}px`,
      },
      [MEDIA_BREAKPOINTS.MEDIUM]: {
        paddingTop: `${vrLineHeight[MEDIA_BREAKPOINTS.MEDIUM]}px`,
      },
      [MEDIA_BREAKPOINTS.SMALL]: {
        paddingTop: `${vrLineHeight[MEDIA_BREAKPOINTS.SMALL]}px`,
      },
    },
  }) as AdditionalStyleSheet;
};

export const PostSidebarComponent: React.FunctionComponent<PostSidebarComponent> = props => {
  const { adId1, adId2, isSecondaryHeaderEnabled, vrLineHeight } = props;
  const style = createStyle(vrLineHeight);
  const headerHeight = getHeaderHeight(isSecondaryHeaderEnabled);
  return (
    <div className={css(style.sidebar)}>
      <Ad id={adId1} />
      <Ad id={adId2} additionalStyle={createAdditionalStyleForStickyAd(headerHeight, vrLineHeight)} />
    </div>
  );
};

const mapThemeToProps = (theme: PostSidebarThemeProps) => ({
  vrLineHeight: theme.vrLineHeight,
});

export const PostSidebar = (props: PostSideBarDataProps) => {
  const themeContext = useTheme(mapThemeToProps, componentConfigurationKey);
  return <PostSidebarComponent {...themeContext} {...props} />;
};
